import script from "./hotelOrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./hotelOrderList.vue?vue&type=script&setup=true&lang=js"

import "./hotelOrderList.vue?vue&type=style&index=0&id=bbb4cbf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbb4cbf6"]])

export default __exports__